import { API_HOST, getHttpGetOptions, getHttpPostOptions, getHttpPutOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/external-registration`;
const getVerifyMemberStatusEndpoint = (externalReference) =>
  `${getEndpoint()}/members/${externalReference}/verify-status`;

export const getFindActiveProgrammesRequest = () => [getEndpoint(), getHttpGetOptions()];

export const getCreateMemberRequest = (member) => [getEndpoint(), getHttpPostOptions(member)];

export const getFlagMemberAsPaidRequest = (memberExternalReference, programmeExternalReference) => [
  getEndpoint(),
  getHttpPutOptions(undefined, { memberExternalReference, programmeExternalReference })
];

export const getVerifyMemberStatusRequest = (externalReference) => [
  getVerifyMemberStatusEndpoint(externalReference),
  getHttpGetOptions()
];
